/* ORDERS */

import BasicLayout from '@/views/layouts/basic.vue';
import orderLinesOverview from '@/views/orderlines/list.vue';

/* ROUTER
-------------------------------------------------------------- */
export default {
    path: 'orderlines',
    name: 'orderlines',
    meta: {title: 'Orderregels'},
    redirect: '/orderlines/overzicht',
    component: BasicLayout,
    children: [
        // Overview routes
        {
            path: 'overzicht',
            name: 'orderlines.overview',
            meta: {title: 'Orderregels'},
            component: orderLinesOverview,
            children: [
                {
                    path: ':status',
                    name: 'orderlines.overview.status',
                    meta: {title: 'Orderregels'},
                    component: orderLinesOverview,
                },
            ],
        }
    ],
};
